import React from 'react';
import styles from './styles/MemberSubsetModal.module.scss';
import Modal, { ModalProps } from '@amzn/awsui-components-core/modal';
interface Props extends ModalProps {
  readonly embedded?: boolean;
  readonly 'data-testid'?: string;
}
export const MemberSubsetContainer: React.FC<Props> = ({ embedded, children, footer, ...props }) =>
  embedded ? (
    <div className={styles.embedded} data-testid={props['data-testid']}>
      {children}
      <div className={styles.embeddedFooter}>{footer}</div>
    </div>
  ) : (
    <Modal {...props} footer={footer}>
      {children}
    </Modal>
  );
